/** Standard admin display: DD/MM/YY */
export function formatRegisteredDate(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
}

/** Standard admin display: HH:mm (24-hour) */
export function formatRegisteredTime(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** Unambiguous display with timezone, e.g. "06 Aug 2026, 03:51:12 pm IST". */
export function formatFullDateTime(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).format(d);
}

/** Standard admin display: DD/MM/YY, HH:mm */
export function formatRegisteredDateTime(value?: string | null): string {
  if (!value) return '—';
  const date = formatRegisteredDate(value);
  if (date === '—') return '—';
  return `${date}, ${formatRegisteredTime(value)}`;
}
